import LandingLayout from "../../../layout/LandingPage/LandingPage";
import {Route, Routes} from "react-router-dom";
import BlogPage from "./blog-page";
import BlogView from "./blog-view";
import PageNotFound from "../../main/404";
import "./index.css"

export default function BlogRoot({className, ...props}) {

    return (
        <LandingLayout>
            <Routes>
                <Route path="/" element={<BlogPage/>}/>
                <Route path="404" element={<PageNotFound/>}/>

                <Route path="/:title" element={<BlogView/>}/>

            </Routes>
        </LandingLayout>

    )
}